<template>
    <Transition name="fade">
        <div v-if="showOverlay" class="network-overlay">
            <div class="network-overlay__content">
                <div class="network-overlay__spinner"></div>
                <p class="network-overlay__text">{{ message }}</p>
            </div>
        </div>
    </Transition>
</template>

<script>
import { networkHandler } from '@/helpers/network-handler'

export default {
    name: 'NetworkOverlay',
    data() {
        return {
            showOverlay: false,
            message: "Відсутнє інтернет-з'єднання. Очікування..."
        }
    },
    mounted() {
        networkHandler.addListener(this.handleNetworkChange)
    },
    beforeUnmount() {
        networkHandler.removeListener(this.handleNetworkChange)
    },
    methods: {
        handleNetworkChange(isOnline) {
            if (!isOnline) {
                this.showOverlay = true
                this.message = "Відсутнє інтернет-з'єднання. Очікування..."
            } else {
                this.message = "З'єднання відновлено. Повторюємо запит..."
                setTimeout(() => {
                    this.showOverlay = false
                }, 1000)
            }
        },
        show() {
            this.showOverlay = true
        },
        hide() {
            this.showOverlay = false
        }
    }
}
</script>

<style lang="scss" scoped>
.network-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;

    &__content {
        text-align: center;
        color: white;
    }

    &__spinner {
        width: 50px;
        height: 50px;
        border: 4px solid rgba(255, 255, 255, 0.3);
        border-top-color: white;
        border-radius: 50%;
        animation: spin 1s linear infinite;
        margin: 0 auto 20px;
    }

    &__text {
        font-size: 16px;
        margin: 0;
    }
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
